import React from 'react'

function Admission_Fee() {
  return (
    <div>Admission_Fee</div>
  )
}

export default Admission_Fee